import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RequisitionsActivitiesContainerComponent } from '../../../containers/single-requisition/requisitions-activities-container/requisitions-activities-container.component';
import { ActivityPageDataService } from '../../../data/single-requisition/activity-page-data.service';
import { ActivityFacade } from '../../../facades/single-requisition/activity.facade';

@Component({
  selector: 'rt-requisitions-activity-page',
  templateUrl: './activity-page.component.html',
  styleUrls: ['./activity-page.component.less'],
  imports: [RequisitionsActivitiesContainerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ActivityPageDataService, ActivityFacade],
})
export class ActivityPageComponent {}
